"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastBatcher = void 0;
var _ToastConfig = require("./ToastConfig");
var _ToastManager = require("./ToastManager");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var ToastBatcher = {
  toastsType: new Map(),
  showToastInternal: function showToastInternal(_ref) {
    var notification = _ref.notification,
      duration = _ref.duration,
      type = _ref.type;
    var notificationType = type;
    if (!type) {
      notificationType = notification.type;
    }
    var toastType = this.toastsType.has(notificationType);
    if (toastType) {
      var _this$toastsType$get = this.toastsType.get(notificationType),
        notifications = _this$toastsType$get.notifications;
      var _this$toastsType$get2 = this.toastsType.get(notificationType),
        id = _this$toastsType$get2.id;
      notifications.push(notification);
      var toastObject = _ToastConfig.ToastConfig[notificationType].multiple(notifications);
      var toastId = _ToastManager.ToastManager.replaceToast(id, _objectSpread(_objectSpread({}, toastObject), {}, {
        duration: duration
      }));
      this.toastsType.set(notificationType, {
        id: toastId,
        notifications: notifications,
        duration: duration
      });
    } else {
      var _toastObject = _ToastConfig.ToastConfig[notificationType].single(notification);
      var _toastId = _ToastManager.ToastManager.addToast(_objectSpread(_objectSpread({}, _toastObject), {}, {
        duration: duration
      }));
      var _notifications = [];
      _notifications.push(notification);
      this.toastsType.set(notificationType, {
        id: _toastId,
        notifications: [].concat(_notifications),
        duration: duration
      });
    }
  },
  showToast: function showToast(_ref2) {
    var notification = _ref2.notification,
      _ref2$duration = _ref2.duration,
      duration = _ref2$duration === void 0 ? 3000 : _ref2$duration,
      type = _ref2.type;
    try {
      this.showToastInternal({
        notification: notification,
        duration: duration,
        type: type
      });
    } catch (err) {
      console.debug("Notifications", err);
    }
  },
  syncUItoast: function syncUItoast(toastsDisplaying) {
    var _this = this;
    var _iterator = _createForOfIteratorHelper(this.toastsType.entries()),
      _step;
    try {
      var _loop = function _loop() {
        var _step$value = _slicedToArray(_step.value, 2),
          toastType = _step$value[0],
          toastInfo = _step$value[1];
        if (!toastsDisplaying.find(function (toast) {
          return toast.id === toastInfo.id;
        })) {
          _this.toastsType["delete"](toastType);
        }
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
};
exports.ToastBatcher = ToastBatcher;
_ToastManager.ToastManager.addListener(ToastBatcher.syncUItoast.bind(ToastBatcher));